import React from "react";
import clsx from "clsx";
import UploadGroupBuilder from "../../UploadGroupBuilder/UploadGroupBuilder";
import Colorpicker from "../../Colorpicker/Colorpicker";
import ErrorHelper from "../../Errors/ErrorHelper";
import Switch from "../../Switch/Switch";
import NumberSpinner from "../../NumberSpinner/NumberSpinner";
import I18n from "i18n-js";

export default class PropertyDetailsBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.autocomplete = null;
    this.licenseeautocomplete = null;
  };

  async componentDidMount() {
    this.autocomplete = await new google.maps.places.Autocomplete(document.getElementById('autocomplete'), { types: ['address'] });
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
    
    this.licenseeautocomplete = await new google.maps.places.Autocomplete(document.getElementById('licenseeautocomplete'), { types: ['address'] });
    this.licenseeautocomplete.addListener("place_changed", this.handleLicenseePlaceSelect);
  };

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });
    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['name', 'app_domain', 'address_1', 'city', 'postal_code', 'state', 'country', 'main_telephone', 'tollfree_telephone', 'mobile_telephone', 'fax_telephone', 'tdd_telephone', 'twilio_number', 'website_url', 'primary_contact_first_name', 'primary_contact_last_name', 'primary_contact_email', 'primary_contact_phone_number', 'default_from_address', 'legal_business_name', 'business_type', 'business_registration_id_type', 'business_registration_number', 'business_regions_of_operation', 'auth_rep_first_name', 'auth_rep_last_name', 'auth_rep_email', 'auth_rep_business_title', 'auth_rep_job_position', 'auth_rep_phone_number', 'auth_rep_country_code'])}
        {this.props.superadmin
          ? this.renderSuperadminForm()
          : this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <div className="row">
          <div
            className="col-md-12"
            style={{ fontSize: "15px", lineHeight: "21px" }}
          >
            <div style={{ fontWeight: "bold" }}>{this.props.name}</div>
            <div>{this.props.address_1}</div>
            {this.props.address_2 ? <div>{this.props.address_2}</div> : null}
            <div>
              {this.props.city}, {this.props.state}
              {this.props.postal_code ? " " + this.props.postal_code : null}
            </div>
            {this.props.country ? <div>{this.props.country}</div> : null}
          </div>
        </div>

        <hr style={{ marginTop: "15px" }} />

        <div className="row">
          <div className="col-md-8">
            <div className="form-group">
              <UploadGroupBuilder
                upload_type="image"
                upload_type_plural="images"
                dropzone_title={"property_logo"}
                upload_groups={
                  this.props.image_group
                    ? [this.props.image_group]
                    : [{ images: [] }]
                }
                onChange={this.props.onImageChange}
                data_table_path={this.props.images_data_table_path}
                multiple={false}
                read_only={false}
                helperText={"logo_image_helper_text"}
                // singleFile={true}
              />
            </div>
            {this.renderFieldErrors("images")}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("link_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_link_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                name="link_color"
                color={this.props.link_color}
                onChange={this.props.onChange}
              />
            </div>
            <div className="form-group">
              <label>
                {I18n.t("button_background_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_button_background_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                name="button_background_color"
                color={this.props.button_background_color}
                onChange={this.props.onChange}
              />
            </div>
            <div className="form-group">
              <label>
                {I18n.t("button_font_color")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_button_font_color_helper_text")}
                ></span>
              </label>
              <br />
              <Colorpicker
                name="button_font_color"
                color={this.props.button_font_color}
                onChange={this.props.onChange}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("main_telephone")}</label>
              <input
                type="text"
                autoComplete="main_telephone"
                className="form-control"
                name="main_telephone"
                onChange={this.props.onChange}
                value={this.props.main_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('main_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("tollfree_telephone")}</label>
              <input
                type="text"
                autoComplete="tollfree_telephone"
                className="form-control"
                name="tollfree_telephone"
                onChange={this.props.onChange}
                value={this.props.tollfree_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('tollfree_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("mobile_telephone")}</label>
              <input
                type="text"
                autoComplete="mobile_telephone"
                className="form-control"
                name="mobile_telephone"
                onChange={this.props.onChange}
                value={this.props.mobile_telephone || ""}
              />
            </div>
          </div>
          {this.renderFieldErrors('mobile_telephone')}
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("fax_telephone")}</label>
              <input
                type="text"
                autoComplete="fax_telephone"
                className="form-control"
                name="fax_telephone"
                onChange={this.props.onChange}
                value={this.props.fax_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('fax_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("tdd_telephone")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("tdd_telephone_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="tdd_telephone"
                className="form-control"
                name="tdd_telephone"
                onChange={this.props.onChange}
                value={this.props.tdd_telephone || ""}
              />
            </div>
          </div>
          {this.renderFieldErrors('tdd_telephone')}
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("email")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("property_email_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="email"
                className="form-control"
                name="email"
                onChange={this.props.onChange}
                value={this.props.email || ""}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("default_from_address")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("default_from_address_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="default_from_address"
                className={ErrorHelper.renderFieldClasses('default_from_address', this.props.errors, 'form-control')}
                name="default_from_address"
                onChange={this.props.onChange}
                value={this.props.default_from_address || ""}
              />
            </div>
            {this.renderFieldErrors("default_from_address")}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("default_from_name")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("default_from_name_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="default_from_name"
                className="form-control"
                name="default_from_name"
                onChange={this.props.onChange}
                value={this.props.default_from_name || ""}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("website_url")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("website_url_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="website_url"
                placeholder={I18n.t('website_url_placeholder')}
                className={ErrorHelper.renderFieldClasses('website_url', this.props.errors, 'form-control')}
                name="website_url"
                onChange={this.props.onChange}
                value={this.props.website_url || ""}
              />
              {ErrorHelper.renderFieldErrors('website_url', this.props.errors)}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("twilio_number")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("twilio_phone_number_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                className="form-control"
                name="twilio_number"
                readOnly={true}
                value={this.props.twilio_number || ""}
              />
            </div>
            {this.renderFieldErrors('twilio_number')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("universal_analytics_tracking_id")}*{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("universal_analytics_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                className="form-control"
                name="universal_analytics_tracking_id"
                onChange={this.props.onChange}
                value={this.props.universal_analytics_tracking_id || ""}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("review_url")}</label>
              <input
                type="text"
                autoComplete="website_url"
                // placeholder={I18n.t('website_url_placeholder')}
                className={ErrorHelper.renderFieldClasses('review_url', this.props.errors, 'form-control')}
                name="review_url"
                onChange={this.props.onChange}
                value={this.props.review_url || ""}
              />
              {ErrorHelper.renderFieldErrors('review_url', this.props.errors)}
            </div>

          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("review_when")}</label>
              <NumberSpinner
                name="review_when"
                min={0}
                max={5}
                className="form-control"
                onChange={this.props.onChange}
                value={this.props.review_when} />  
            </div>
          </div>
        </div>

      </div>
    );
  }

  renderSuperadminForm() {
    return (
      <div>
        <div>
          <h5>{I18n.t('hotel')}</h5>
        </div>
        <br />
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("name")}*</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="name"
                onChange={this.props.onChange}
                value={this.props.name || ""}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>
                {I18n.t("app_domain")}*{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("app_domain_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="app_domain"
                onChange={this.props.onChange}
                value={this.props.app_domain || ""}
              />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label style={{ marginRight: "4px" }}>
                {" "}
                {I18n.t("reservation_auto_assign")}{" "}
              </label>
              <span
                className="ss-help help"
                title={I18n.t("reservation_auto_assign_helper_text")}
              ></span>
              <br />
              <Switch
                onText="yes"
                switchId="auto-assign-rooms"
                offText="no"
                name="auto_assign"
                onChange={this.props.onChangeAutoAssign}
                value={this.props.auto_assign}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_1")}*</label>
              <input
                id="autocomplete"
                type="text"
                className="form-control"
                name="address_1"
                onChange={this.props.onChange}
                value={this.props.address_1 || ""}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_2")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="address_2"
                onChange={this.props.onChange}
                value={this.props.address_2 || ""}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("city")}*</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="city"
                onChange={this.props.onChange}
                value={this.props.city || ""}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("state_province")}*</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="state"
                onChange={this.props.onChange}
                value={this.props.state || ""}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("postal_code")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className={ErrorHelper.renderFieldClasses('postal_code', this.props.errors, 'form-control')}
                name="postal_code"
                onChange={this.props.onChange}
                value={this.props.postal_code || ""}
              />
              {ErrorHelper.renderFieldErrors('postal_code', this.props.errors)}
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("country")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className={ErrorHelper.renderFieldClasses('country', this.props.errors, 'form-control')}
                name="country"
                onChange={this.props.onChange}
                value={this.props.country || ""}
              />
              {ErrorHelper.renderFieldErrors('country', this.props.errors)}
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("main_telephone")}</label>
              <input
                type="text"
                autoComplete="main_telephone"
                className="form-control"
                name="main_telephone"
                onChange={this.props.onChange}
                value={this.props.main_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('main_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("tollfree_telephone")}</label>
              <input
                type="text"
                autoComplete="tollfree_telephone"
                className="form-control"
                name="tollfree_telephone"
                onChange={this.props.onChange}
                value={this.props.tollfree_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('tollfree_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("mobile_telephone")}</label>
              <input
                type="text"
                autoComplete="mobile_telephone"
                className="form-control"
                name="mobile_telephone"
                onChange={this.props.onChange}
                value={this.props.mobile_telephone || ""}
              />
            </div>
          </div>
          {this.renderFieldErrors('mobile_telephone')}
        </div>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("fax_telephone")}</label>
              <input
                type="text"
                autoComplete="fax_telephone"
                className="form-control"
                name="fax_telephone"
                onChange={this.props.onChange}
                value={this.props.fax_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('fax_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("tdd_telephone")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("tdd_telephone_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                autoComplete="tdd_telephone"
                className="form-control"
                name="tdd_telephone"
                onChange={this.props.onChange}
                value={this.props.tdd_telephone || ""}
              />
            </div>
            {this.renderFieldErrors('tdd_telephone')}
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{I18n.t("email")}</label>
              <input
                type="text"
                autoComplete="email"
                className="form-control"
                name="email"
                onChange={this.props.onChange}
                value={this.props.email || ""}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <h5>{I18n.t('licensee')}</h5>

        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{`${I18n.t('legal_business_name')}`}</label>
              <input
                id='legal_business_name'
                type="text"
                name='legal_business_name'
                className={ErrorHelper.renderFieldClasses('legal_business_name', this.props.errors, 'form-control')}
                value={this.props.legal_business_name || ""}
                onChange={this.props.onChange}
              />
              {ErrorHelper.renderFieldErrors('legal_business_name', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('business_type')}`}</label>
              <select
                id='business_type'
                name='business_type'
                className={ErrorHelper.renderFieldClasses('business_type', this.props.errors, 'form-control')}
                defaultValue={this.props.business_type || 'please_select_one'}
                onChange={this.props.onChange}>
                  <option value='please_select_one' disabled>{I18n.t('please_select_one')}</option>
                  {this.options(this.props.business_type_options)}
              </select>
              {ErrorHelper.renderFieldErrors('business_type', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('business_registration_id_type')}`}</label>
              <select
                id='business_registration_id_type'
                name='business_registration_id_type'
                className={ErrorHelper.renderFieldClasses('business_registration_id_type', this.props.errors, 'form-control')}
                defaultValue={this.props.business_registration_id_type || 'please_select_one'}
                onChange={this.props.onChange}>
                  <option value='please_select_one' disabled>{I18n.t('please_select_one')}</option>
                  {this.options(this.props.business_registration_id_type_options)}
              </select>
              {ErrorHelper.renderFieldErrors('business_registration_id_type', this.props.errors)}
            </div>
          </div>
        </div>
        <div className="row">
        <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('business_registration_number')}`}
                <span
                  className="ss-help help"
                  title={I18n.t('business_registration_number_helper')}
                ></span>
              </label>
              <input
                id='business_registration_number'
                type="text"
                name='business_registration_number'
                className={ErrorHelper.renderFieldClasses('business_registration_number', this.props.errors, 'form-control')}
                value={this.props.business_registration_number || ""}
                onChange={this.props.onChange}
              />
              {ErrorHelper.renderFieldErrors('business_registration_number', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('business_regions_of_operation')}`}</label>
              <select
                id='business_regions_of_operation'
                name='business_regions_of_operation'
                className={ErrorHelper.renderFieldClasses('business_regions_of_operation', this.props.errors, 'form-control')}
                defaultValue={this.props.business_regions_of_operation || 'please_select_one'}
                onChange={this.props.onChange}>
                  <option value='please_select_one' disabled>{I18n.t('please_select_one')}</option>
                  {this.options(this.props.business_regions_of_operation_options)}
              </select>
              {ErrorHelper.renderFieldErrors('business_regions_of_operation', this.props.errors)}
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>
                {I18n.t("website_url")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("website_url_helper_text")}
                ></span>
              </label>
              <input
                type="text"
                placeholder={I18n.t('website_url_placeholder')}
                autoComplete="website_url"
                className={ErrorHelper.renderFieldClasses('website_url', this.props.errors, 'form-control')}
                name="website_url"
                onChange={this.props.onChange}
                value={this.props.website_url || ""}
              />
              {ErrorHelper.renderFieldErrors('website_url', this.props.errors)}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_1")}</label>
              <input
                id="licenseeautocomplete"
                type="text"
                className="form-control"
                name="licensee_address_1"
                onChange={this.props.onChange}
                value={this.props.licensee_address_1 || ""}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group">
              <label>{I18n.t("address_2")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="licensee_address_2"
                onChange={this.props.onChange}
                value={this.props.licensee_address_2 || ""}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("city")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="licensee_city"
                onChange={this.props.onChange}
                value={this.props.licensee_city || ""}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("state_province")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className="form-control"
                name="licensee_state"
                onChange={this.props.onChange}
                value={this.props.licensee_state || ""}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("postal_code")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className={ErrorHelper.renderFieldClasses('postal_code', this.props.errors, 'form-control')}
                name="licensee_postal_code"
                onChange={this.props.onChange}
                value={this.props.licensee_postal_code || ""}
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t("country")}</label>
              <input
                type="text"
                autoComplete="new-password"
                className={ErrorHelper.renderFieldClasses('country', this.props.errors, 'form-control')}
                name="licensee_country"
                onChange={this.props.onChange}
                value={this.props.licensee_country || ""}
              />
            </div>
          </div>
        </div>

        <hr style={{ marginTop: "10px" }} />

        <div>
          <h5>{I18n.t('primary_contact')}</h5>
          <br />
          {this.renderPrimaryContact()}
        </div>
        <hr style={{ marginTop: "15px" }} />
      </div>
    );
  };

  renderPrimaryContact = () => {
    return(
      <>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('first_name')}</label>
              <input
                type="text"
                className={ErrorHelper.renderFieldClasses('primary_contact_first_name', this.props.errors, 'form-control')}
                name="primary_contact_first_name"
                onChange={this.props.onChange}
                value={this.props.primary_contact_first_name || ""}
              />
              {ErrorHelper.renderFieldErrors('primary_contact_first_name', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('last_name')}</label>
              <input
                type="text"
                className={ErrorHelper.renderFieldClasses('primary_contact_last_name', this.props.errors, 'form-control')}
                name="primary_contact_last_name"
                onChange={this.props.onChange}
                value={this.props.primary_contact_last_name || ""}
              />
              {ErrorHelper.renderFieldErrors('primary_contact_last_name', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('email')}</label>
              <input
                type="text"
                className={ErrorHelper.renderFieldClasses('primary_contact_email', this.props.errors, 'form-control')}
                name="primary_contact_email"
                onChange={this.props.onChange}
                value={this.props.primary_contact_email || ""}
              />
              {ErrorHelper.renderFieldErrors('primary_contact_email', this.props.errors)}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('country_code')}`}</label>
              <input
                id='auth_rep_country_code'
                type="text"
                name='auth_rep_country_code'
                className={ErrorHelper.renderFieldClasses('auth_rep_country_code', this.props.errors, 'form-control')}
                value={this.props.auth_rep_country_code || ""}
                onChange={this.props.onChange}
              />
              {ErrorHelper.renderFieldErrors('auth_rep_country_code', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{I18n.t('phone_number')}</label>
              <input
                type="text"
                className={ErrorHelper.renderFieldClasses('primary_contact_phone_number', this.props.errors, 'form-control')}
                name="primary_contact_phone_number"
                onChange={this.props.onChange}
                value={this.props.primary_contact_phone_number || ""}
              />
              {ErrorHelper.renderFieldErrors('primary_contact_phone_number', this.props.errors)}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('business_title')}`}</label>
              <input
                id='auth_rep_business_title'
                type="text"
                name='auth_rep_business_title'
                className={ErrorHelper.renderFieldClasses('auth_rep_business_title', this.props.errors, 'form-control')}
                value={this.props.auth_rep_business_title || ""}
                onChange={this.props.onChange}
              />
              {ErrorHelper.renderFieldErrors('auth_rep_business_title', this.props.errors)}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>{`${I18n.t('job_position')}`}</label>
              <select
                id='auth_rep_job_position'
                name='auth_rep_job_position'
                className={ErrorHelper.renderFieldClasses('auth_rep_job_position', this.props.errors, 'form-control')}
                defaultValue={this.props.auth_rep_job_position || 'please_select_one'}
                onChange={this.props.onChange}>
                  <option value='please_select_one' disabled>{I18n.t('please_select_one')}</option>
                  {this.options(this.props.auth_rep_job_position_options)}
              </select>
              {ErrorHelper.renderFieldErrors('auth_rep_job_position', this.props.errors)}
            </div>
          </div>
        </div>
      </>
    );
  };

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, classname) {
    var classname = classname || "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  };

  handlePlaceSelect = () => {
    let addressObject = this.autocomplete.getPlace()
    let address = addressObject.address_components
    for (let i = 0, ilen = address.length; i < ilen; i++) {
      for (let j = 0, jlen = address[i].types.length; j < jlen; j++) {
        if (address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if (address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if (address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if (address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if (address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if (address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }

    let objForState = {
      address_1: street_number ? `${street_number} ${route}` : route,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code
    };
    
    this.props.onGeoSelectAddress(objForState);
  };

  handleLicenseePlaceSelect = () => {
    let addressObject = this.licenseeautocomplete.getPlace()
    let address = addressObject.address_components
    for (let i = 0, ilen = address.length; i < ilen; i++) {
      for (let j = 0, jlen = address[i].types.length; j < jlen; j++) {
        if (address[i].types[j] === "street_number") {
          var street_number = address[i].long_name
        }
        if (address[i].types[j] === "route") {
          var route = address[i].long_name
        }
        if (address[i].types[j] === "locality") {
          var city = address[i].long_name
        }
        if (address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name
        }
        if (address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name
        }
        if (address[i].types[j] === "country") {
          var country = address[i].long_name
        }
      }
    }

    let objForState = {
      licensee_address_1: street_number ? `${street_number} ${route}` : route,
      licensee_city: city,
      licensee_state: state_province,
      licensee_country: country,
      licensee_postal_code: postal_code
    };
    
    this.props.onGeoSelectAddress(objForState);
  };

  options(options) {
    return options.map((option, idx) => {
      return <option key={idx} value={option}>{option}</option>
    });
  }
};
